import { observer } from 'mobx-react';
import * as React from 'react';
import { FlexRow, Grid } from 'ui-toolkit';
import PageWithOutsideLinks from './PageWithOutsideLinks';
import { PolicyEditButton } from './PolicyEditButton';

interface IEndorsementsProps {
  data: string[];
  cdBuilderPage: string;
  errorMessage: boolean;
  showSaveSuccess: boolean;
  showSaveSpinner: boolean;
  onUpdatePageClick: () => void;
}

interface IEndorsementsState {
  onOutsideClick: boolean;
}

class Endorsements extends React.Component<IEndorsementsProps, IEndorsementsState> {
  public readonly state: IEndorsementsState = {
    onOutsideClick: false,
  };

  public componentWillReceiveProps(newProps: IEndorsementsProps) {
    if (this.state.onOutsideClick && this.props.showSaveSpinner && !newProps.showSaveSpinner) {
      this.toggleUpdateWindow();
    }
  }

  public render() {
    return (
      <React.Fragment>
        <FlexRow justifyContent={'space-between'}>
          <h2>Endorsements</h2>
          <PolicyEditButton />
        </FlexRow>
        <Grid columnCount={2}>
          {this.props.data.map((endorsement) => (
            <span key={endorsement}>{endorsement}</span>
          ))}
          <PageWithOutsideLinks
            outsideClick={this.state.onOutsideClick}
            showUpdateSpinner={this.props.showSaveSpinner}
            showUpdateSuccess={this.props.showSaveSuccess}
            pageContainsError={this.props.errorMessage}
            onUpdatePageClick={this.props.onUpdatePageClick}
          />
        </Grid>
      </React.Fragment>
    );
  }

  private toggleUpdateWindow = () => {
    this.setState((state) => ({
      onOutsideClick: !state.onOutsideClick,
    }));
  };
}

export default observer(Endorsements);
